import { render } from "./LogOut.vue?vue&type=template&id=1452bb54"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"
script.render = render

export default script